import React, {useContext, useEffect, useState} from "react";
import $ from "jquery";
import moment from "moment";
import CalendarIcon from "../../../icons/CalendarIcon";
import LeftArrow from "../../../icons/LeftArrow";
import RightArrow from "../../../icons/RightArrow";
import usePrevious from "../../../../class/tool/usePrevious";
import StringTools from "../../../../class/tool/StringTools";
import Store from "../../../../stories/_account/Stores/Store";
import Company from "../../../../stories/_account/Companies/Company";
import StatisticContext from "../../../../context/StatisticContext";
import "../../../../css/form/DateSelector.css";
import "moment/locale/fr";

const DateSelector = props => {
    moment.locale("fr");
    const { random, attribute, classname, type, value, baseValue, change, validCalendar, noCompare } = props;
    const { loading } = useContext(StatisticContext);
    const [ calendarOpened, setCalendarOpened ] = useState(false);
    const [ calendars, setCalendars ] = useState([]);
    const [ typeCompare, setTypeCompare ] = useState(type);
    const [ nbClick, setNbClick ] = useState(1);
    const [ dateSelectorElmt, setDateSelectorElmt ] = useState(null);
    const [ calendarElmt, setCalendarElmt ] = useState(null);
    const env = JSON.parse(localStorage.getItem('env'));
    const idRandom = random !== undefined ? random : Math.floor(Math.random() * 999999);
    const calendarWiths = {
        "dual_day": 430,
        "day": 430,
        "month": 240,
        "quarter": 240,
        "year": 500
    };
    const prevType = usePrevious(typeCompare);
    let inMoveCalendar = false;

    const initCalendars = (reinit = false) => {
        setDateSelectorElmt($("#DateSelector_" + idRandom));
        setCalendarElmt($("#calendar_" + idRandom));

        let calendarsTmp = calendars.slice();

        if (calendarsTmp.length === 0 || reinit) {
            calendarsTmp = [];
            let maxValue;

            switch (typeCompare) {
                case "dual_day":
                    maxValue = value.end !== null ? value.end : (value.begin !== null ? value.begin : moment().format());

                    calendarsTmp = [
                        {
                            date: moment(maxValue).startOf('month').subtract(2, 'months'),
                            content: buildDaysCalendar(moment(maxValue).startOf('month').subtract(2, 'months'))
                        },
                        {
                            date: moment(maxValue).subtract(1, 'months'),
                            content: buildDaysCalendar(moment(maxValue).startOf('month').subtract(1, 'months'))
                        },
                        {
                            date: moment(maxValue).startOf('month'),
                            content: buildDaysCalendar(moment(maxValue).startOf('month'))
                        },
                        {
                            date: moment(maxValue).startOf('month').add(1, 'months'),
                            content: buildDaysCalendar(moment(maxValue).startOf('month').add(1, 'months'))
                        }
                    ];

                    break;
                case "day":
                    maxValue = value.end !== null ? value.end : (value.begin !== null ? value.begin : moment().format());

                    calendarsTmp = [
                        {
                            date: moment(maxValue).subtract(1, 'months'),
                            content: buildDaysCalendar(moment(maxValue).startOf('month').subtract(1, 'months'))
                        },
                        {
                            date: moment(maxValue).startOf('month'),
                            content: buildDaysCalendar(moment(maxValue).startOf('month'))
                        },
                        {
                            date: moment(maxValue).startOf('month').add(1, 'months'),
                            content: buildDaysCalendar(moment(maxValue).startOf('month').add(1, 'months'))
                        }
                    ];

                    break;
                case "month":
                    maxValue = value.end !== null ? value.end : (value.begin !== null ? value.begin : moment().format());

                    calendarsTmp = [
                        {
                            date: moment(maxValue).startOf('year').subtract(1, 'years'),
                            content: buildMonthsCalendar(moment(maxValue).startOf('year').subtract(1, 'years'))
                        },
                        {
                            date: moment(maxValue).startOf('year'),
                            content: buildMonthsCalendar(moment(maxValue).startOf('year'))
                        },
                        {
                            date: moment(maxValue).startOf('year').add(1, 'years'),
                            content: buildMonthsCalendar(moment(maxValue).startOf('year').add(1, 'years'))
                        }
                    ];

                    break;
                case "quarter":
                    maxValue = value.end !== null ? value.end : (value.begin !== null ? value.begin : moment().format());

                    calendarsTmp = [
                        {
                            date: moment(maxValue).startOf('year').subtract(1, 'years'),
                            content: buildQuartersCalendar(moment(maxValue).startOf('year').subtract(1, 'years'))
                        },
                        {
                            date: moment(maxValue).startOf('year'),
                            content: buildQuartersCalendar(moment(maxValue).startOf('year'))
                        },
                        {
                            date: moment(maxValue).startOf('year').add(1, 'years'),
                            content: buildQuartersCalendar(moment(maxValue).startOf('year').add(1, 'years'))
                        }
                    ];

                    break;
                case "year":
                    maxValue = value.end !== null ? value.end : (value.begin !== null ? value.begin : moment().format());

                    calendarsTmp = [
                        {
                            content: buildYearsCalendar()
                        }
                    ];

                    break;
                default: break;
            }

            if (!window.matchMedia('(max-width: 640px)').matches)
                $("#containerCalendar").css({marginLeft: (typeCompare !== "year" ? "-" + calendarWiths[typeCompare] + "px" : "0")});
            else
                $("#containerCalendar").css({marginLeft: (typeCompare !== "year" ? "-" + $("window").width() + "px" : "0")});
        }
        else {
            switch (typeCompare) {
                case "dual_day":
                case "day":
                    for (let i = 0; i < calendarsTmp.length; i++) {
                        calendarsTmp[i].content = buildDaysCalendar(moment(calendarsTmp[i].date));
                    }

                    break;
                case "month":
                    for (let i = 0; i < calendarsTmp.length; i++) {
                        calendarsTmp[i].content = buildMonthsCalendar(moment(calendarsTmp[i].date));
                    }

                    break;
                case "quarter":
                    for (let i = 0; i < calendarsTmp.length; i++) {
                        calendarsTmp[i].content = buildQuartersCalendar(moment(calendarsTmp[i].date));
                    }

                    break;
                case "year":
                    calendarsTmp[0].content = buildYearsCalendar();

                    break;
                default: break;
            }
        }

        setCalendars(calendarsTmp);
    }
    const initCalendarPosition = () => {
        if (dateSelectorElmt === null || calendarElmt === null || dateSelectorElmt.length === 0 || calendarElmt.length === 0)
            return;

        if (type === "dual_day" && window.matchMedia('(max-width: 1000px)').matches)
            setTypeCompare("day");
        if (!window.matchMedia('(max-width: 640px)').matches) {
            const offset = dateSelectorElmt.offset();
            const yPos = offset.top + dateSelectorElmt.height() + 5;
            let xPos = offset.left + dateSelectorElmt.width() - calendarElmt.outerWidth();

            if (xPos < 0)
                xPos = offset.left;

            if (xPos + calendarElmt.outerWidth() >= $(document).width())
                xPos = $(document).width() - calendarElmt.outerWidth() - 15;

            calendarElmt.css({ top: yPos, left: xPos });
        }
    }
    const buildDatesString = (vs = false) => {
        let dateFormat;

        switch (typeCompare) {
            case "month":
                dateFormat = "MMM YYYY";
                break;
            case "quarter":
                dateFormat = "Qo YYYY";
                break;
            case "year":
                dateFormat = "YYYY";
                break;
            case "dual_day":
            case "day":
            default:
                dateFormat = "DD MMM YYYY";
                break;
        }

        let string = vs ? "- vs. " : "";
        string += StringTools.capitalizeFirstLetter(moment(value.begin).format(dateFormat));
        string = withEnd(string, dateFormat);

        return string;
    }
    const buildComparesString = () => {
        let dateFormat;

        switch (typeCompare) {
            case "month":
                dateFormat = "MMM YYYY";
                break;
            case "quarter":
                dateFormat = "Qo YYYY";
                break;
            case "year":
                dateFormat = "YYYY";
                break;
            case "dual_day":
            case "day":
            default:
                dateFormat = "DD MMM YYYY";
                break;
        }

        let createdDate = moment();

        switch (env.type) {
            case "company":
                for (let i in env.stores) {
                    if (moment(env.stores[i].created_at).isBefore(createdDate)) {
                        createdDate = moment(env.stores[i].created_at);
                    }
                }

                break;
            case "store":
                createdDate = moment(env.created_at);
                break;
            default: break;
        }

        let string = "";
        let start = moment(value.begin);
        let end = value.end !== null ? moment(value.end) : null;

        switch (typeCompare) {
            case "dual_day":
            case "day":
                if (Math.abs(moment(start).diff(moment(end), 'days')) > 1) {
                    start.subtract(1, "years");

                    if (end !== null)
                        end.subtract(1, "years");
                }
                else {
                    if (moment(start).subtract(1, "years").isAfter(createdDate)) {
                        start.subtract(1, "years");

                        if (end !== null)
                            end.subtract(1, "years");
                    }
                    else if (moment(start).subtract(1, "weeks").isAfter(createdDate)) {
                        start.subtract(1, "weeks");

                        if (end !== null)
                            end.subtract(1, "weeks");
                    }
                    else {
                        start.subtract(1, "days");

                        if (end !== null)
                            end.subtract(1, "days");
                    }
                }

                break;
            case "month":
                if (Math.abs(moment(start).diff(moment(end), 'months')) > 1) {
                    start.subtract(1, "years");

                    if (end !== null)
                        end.subtract(1, "years").endOf("month");
                }
                else {
                    if (moment(start).subtract(1, "years").isAfter(createdDate)) {
                        start.subtract(1, "years");

                        if (end !== null)
                            end.subtract(1, "years").endOf("month");
                    }
                    else {
                        start.subtract(1, "months");

                        if (end !== null)
                            end.subtract(1, "months").endOf("month");
                    }
                }

                break;
            case "quarter":
                if (Math.abs(moment(start).diff(moment(end), 'months')) > 3) {
                    start.subtract(1, "years");

                    if (end !== null)
                        end.subtract(1, "years").endOf("month");
                }
                else {
                    if (moment(start).subtract(1, "years").isAfter(createdDate)) {
                        start.subtract(1, "years");

                        if (end !== null)
                            end.subtract(1, "years").endOf("month");
                    }
                    else {
                        start.subtract(1, "quarters");

                        if (end !== null)
                            end.subtract(1, "quarters").endOf("month");
                    }
                }

                break;
            case "year":
                start.subtract(1, "years");

                if (end !== null)
                    end.subtract(1, "years");

                break;
            default:
                break;
        }

        string += StringTools.capitalizeFirstLetter(start.format(dateFormat));

        if (end !== null && !start.isSame(end, typeCompare === "dual_day" ? "day" : typeCompare)) {
            string += " - " + StringTools.capitalizeFirstLetter(end.format(dateFormat));
        }

        return string;
    }
    const withEnd = (string, dateFormat) => {
        if (value.end === null)
            return string;

        switch (typeCompare) {
            case "dual_day":
            case "day":
                if (Math.abs(moment(value.begin).diff(moment(value.end), 'days')) > 1)
                    string += " - " + StringTools.capitalizeFirstLetter(moment(value.end).format(dateFormat));

                break;
            case "month":
                if (Math.abs(moment(value.begin).diff(moment(value.end), 'months')) > 1)
                    string += " - " + StringTools.capitalizeFirstLetter(moment(value.end).format(dateFormat));

                break;
            case "year":
                if (Math.abs(moment(value.begin).diff(moment(value.end), 'years')) > 1)
                    string += " - " + StringTools.capitalizeFirstLetter(moment(value.end).format(dateFormat));

                break;
            default: break;
        }

        return string;
    }
    const close = () => {
        setNbClick(1);
        open();
    }
    const valid = () => {
        setNbClick(1);
        open();
        validCalendar();
    }
    const open = () => {
        if (loading.global)
            return;

        initCalendarPosition();
        setCalendarOpened(!calendarOpened);
    }
    const toLeft = () => {
        if (inMoveCalendar)
            return;

        inMoveCalendar = true;
        let container = $("#containerCalendar");
        let left;

        if (!window.matchMedia('(max-width: 640px)').matches)
            left = (parseInt(container.css("marginLeft").replace('px', '')) + calendarWiths[typeCompare]) + "px";
        else
            left = (parseInt(container.css("marginLeft").replace('px', '')) + $("window").width()) + "px"

        container.animate(
            {
                marginLeft: left
            },
            200, "swing", function() {
                inMoveCalendar = false;

                let calendarsTmp = calendars.slice();
                let baseDate = moment(calendars[0].date);
                let subDate;

                switch (typeCompare) {
                    case "dual_day":
                    case "day":
                        subDate = baseDate.subtract(1, 'months').format();

                        calendarsTmp.splice(0, 0, {
                            date: moment(subDate),
                            content: buildDaysCalendar(moment(subDate))
                        });

                        break;
                    case "month":
                        subDate = baseDate.subtract(1, 'years').format();

                        calendarsTmp.splice(0, 0, {
                            date: moment(subDate),
                            content: buildMonthsCalendar(moment(subDate))
                        });

                        break;
                    case "quarter":
                        subDate = baseDate.subtract(1, 'years').format();

                        calendarsTmp.splice(0, 0, {
                            date: moment(subDate),
                            content: buildQuartersCalendar(moment(subDate))
                        });

                        break;
                    default: return;
                }

                calendarsTmp.splice(-1);

                setCalendars(calendarsTmp);

                if (!window.matchMedia('(max-width: 640px)').matches)
                    $("#containerCalendar").css({marginLeft: "-" + calendarWiths[typeCompare] + "px"});
                else
                    $("#containerCalendar").css({marginLeft: "-" + $("window").width() + "px"});
            }
        );
    }
    const toRight = () => {
        if (inMoveCalendar)
            return;

        inMoveCalendar = true;
        let container = $("#containerCalendar");
        let left;

        if (!window.matchMedia('(max-width: 640px)').matches)
            left = (parseInt(container.css("marginLeft").replace('px', '')) - calendarWiths[typeCompare]) + "px";
        else
            left = (parseInt(container.css("marginLeft").replace('px', '')) - $("window").width()) + "px"

        container.animate(
            {
                marginLeft: left
            },
            200, "swing", function() {
                inMoveCalendar = false;

                let calendarsTmp = calendars.slice();
                let baseDate = moment(calendars[calendars.length-1].date);
                let addingDate;

                switch (typeCompare) {
                    case "dual_day":
                    case "day":
                        addingDate = baseDate.add(1, 'months').format();

                        calendarsTmp.push({
                            date: moment(addingDate),
                            content: buildDaysCalendar(moment(addingDate))
                        });

                        break;
                    case "month":
                        addingDate = baseDate.add(1, 'years').format();

                        calendarsTmp.push({
                            date: moment(addingDate),
                            content: buildMonthsCalendar(moment(addingDate))
                        });

                        break;
                    case "quarter":
                        addingDate = baseDate.add(1, 'years').format();

                        calendarsTmp.push({
                            date: moment(addingDate),
                            content: buildQuartersCalendar(moment(addingDate))
                        });

                        break;
                    default: return;
                }

                calendarsTmp.shift();

                setCalendars(calendarsTmp);

                if (!window.matchMedia('(max-width: 640px)').matches)
                    $("#containerCalendar").css({marginLeft: "-" + calendarWiths[typeCompare] + "px"});
                else
                    $("#containerCalendar").css({marginLeft: "-" + $("window").width() + "px"});
            }
        );
    }
    const calendarContent = () => {
        let shortcuts = [];

        switch (typeCompare) {
            case "day":
                if (attribute !== "dateCompare")
                    shortcuts = [
                    {
                        date: moment().startOf('day'),
                        label: "Aujourd'hui"
                    }
                ];

                return <>
                    <div className={"arrows " + typeCompare}>
                        <LeftArrow classname={"arrow left"} click={toLeft} />
                        <RightArrow classname={"arrow right"} click={toRight} />
                    </div>
                    <div id={"containerCalendar"} className={"container"}>
                        {
                            calendars.map((calendar, index) => (
                                <div key={index} className={"item"}>{calendar.content}</div>
                            ))
                        }
                    </div>
                    <div className={"footer"}>
                        <div className={"shortcuts"}>
                            {
                                shortcuts.map((shortcut, index) => (
                                    <p key={index} className={"short"} onClick={() => { clickOnDate(shortcut.date, true) }}>{ shortcut.label }</p>
                                ))
                            }
                        </div>
                        <p className={"valid"} onClick={valid}>Valider</p>
                    </div>
                </>
            case "dual_day":
                if (attribute !== "dateCompare")
                    shortcuts = [
                    {
                        date: moment().startOf('day'),
                        label: "Aujourd'hui"
                    },
                    {
                        date: moment().subtract(1, 'days'),
                        label: "Hier"
                    },
                    {
                        date: moment().startOf("week").subtract(1, 'weeks').day(moment().isoWeekday()),
                        label: StringTools.capitalizeFirstLetter(moment().startOf("week").subtract(1, 'weeks').day(moment().isoWeekday()).format("dddd")) + " dernier"
                    },
                    {
                        date: moment().startOf("week").subtract(1, 'months').day(moment().isoWeekday()),
                        label: StringTools.capitalizeFirstLetter(moment().startOf("week").subtract(1, 'months').day(moment().isoWeekday()).format("dddd")) + ", il y a 1 mois"
                    },
                    {
                        date: moment().startOf("week").subtract(1, 'years').day(moment().isoWeekday()),
                        label: StringTools.capitalizeFirstLetter(moment().startOf("week").subtract(1, 'years').day(moment().isoWeekday()).format("dddd")) + ", il y a 1 an"
                    },
                    {
                        date: moment().subtract(1, 'years'),
                        label: StringTools.capitalizeFirstLetter(moment().subtract(1, 'years').format("ddd DD MMM")) + ", il y a 1 an"
                    }
                ];

                return <>
                    <div className={"arrows " + typeCompare}>
                        <LeftArrow classname={"arrow left"} click={toLeft} />
                        <RightArrow classname={"arrow right"} click={toRight} />
                    </div>
                    <div id={"containerCalendar"} className={"container"}>
                        {
                            calendars.map((calendar, index) => (
                                <div key={index} className={"item"}>{calendar.content}</div>
                            ))
                        }
                    </div>
                    <div className={"footer"}>
                        <div className={"shortcuts"}>
                            {
                                shortcuts.map((shortcut, index) => (
                                    <p key={index} className={"short"} onClick={() => { clickOnDate(shortcut.date, true) }}>{ shortcut.label }</p>
                                ))
                            }
                        </div>
                        <p className={"valid"} onClick={valid}>Valider</p>
                    </div>
                </>
            case "month":
                if (attribute !== "dateCompare")
                    shortcuts = [];

                return <>
                    <div className={"arrows " + typeCompare}>
                        <LeftArrow classname={"arrow left"} click={toLeft}/>
                        <RightArrow classname={"arrow right"} click={toRight}/>
                    </div>
                    <div id={"containerCalendar"} className={"container"}>
                        {calendars.map((calendar, index) => (<div key={index} className={"item"}>{calendar.content}</div>))}
                    </div>
                    <div className={"footer"}>
                        <div className={"shortcuts"}>
                            {shortcuts.map((shortcut, index) => (<p key={index} className={"short"} onClick={() => { clickOnDate(shortcut.date, true) }}>{shortcut.label}</p>))}
                        </div>
                        <p className={"valid"} onClick={valid}>Valider</p>
                    </div>
                </>
            case "quarter":
                if (attribute !== "dateCompare")
                    shortcuts = [];

                return <>
                    <div className={"arrows " + typeCompare}>
                        <LeftArrow classname={"arrow left"} click={toLeft}/>
                        <RightArrow classname={"arrow right"} click={toRight}/>
                    </div>
                    <div id={"containerCalendar"} className={"container"}>
                        {calendars.map((calendar, index) => (<div key={index} className={"item"}>{calendar.content}</div>))}
                    </div>
                    <div className={"footer"}>
                        <div className={"shortcuts"}>
                            {shortcuts.map((shortcut, index) => (<p key={index} className={"short"} onClick={() => { clickOnDate(shortcut.date, true) }}>{shortcut.label}</p>))}
                        </div>
                        <p className={"valid"} onClick={valid}>Valider</p>
                    </div>
                </>
            case "year":
                if (attribute !== "dateCompare")
                    shortcuts = [];

                return <>
                    <div className={"arrows " + typeCompare}>
                        <LeftArrow classname={"arrow left"} click={toLeft}/>
                        <RightArrow classname={"arrow right"} click={toRight}/>
                    </div>
                    <div id={"containerCalendar"} className={"container"}>
                        {calendars.map((calendar, index) => (<div key={index} className={"item"}>{calendar.content}</div>))}
                    </div>
                    <div className={"footer"}>
                        <div className={"shortcuts"}>
                            {shortcuts.map((shortcut, index) => (<p key={index} className={"short"} onClick={() => { clickOnDate(shortcut.date, true) }}>{shortcut.label}</p>))}
                        </div>
                        <p className={"valid"} onClick={valid}>Valider</p>
                    </div>
                </>
            default:
                break;
        }
    }
    const buildDaysCalendar = baseDate => {
        baseDate.startOf("month");
        let initialDate = moment(baseDate.format());
        let datas = emptyDictDates();
        let nbDays = baseDate.daysInMonth();
        let index = 0;
        let days = [];
        let indexDays = [0, 1, 2, 3, 4, 5, 6];

        for (let i = 1; i <= 7; i++) {
            days.push(StringTools.capitalizeFirstLetter(moment(initialDate).startOf("week").day(i).format("ddd")));
        }
        for (let i = 1; i <= nbDays; i++) {
            if (index >= datas.length)
                break;

            if (datas[index].week.number === null) {
                datas[index].week.number = baseDate.format("W");
                datas[index].week.year = baseDate.format("YYYY");
            }

            datas[index].days[parseInt(baseDate.format("e"))] = moment(baseDate.format());

            if (parseInt(baseDate.format("e")) === 6)
                index++;

            baseDate.add(1, "days");
        }

        return <>
            <p className={"title" + (initialDate.isSame(moment(), 'month') ? " now" : "")}>{ StringTools.capitalizeFirstLetter(initialDate.format("MMMM YYYY")) }</p>
            <table>
                <tbody>
                    <tr className={"header"}>
                        {
                            !window.matchMedia('(max-width: 640px)').matches
                            && <th></th>
                        }
                        {
                            days.map((day, index) => (
                                <th key={index} className={"light"}><p>{day}</p></th>
                            ))
                        }
                    </tr>
                    {
                        datas.map((object, index) => (
                            object.week.number !== null
                            && <tr key={index}>
                                {
                                    !window.matchMedia('(max-width: 640px)').matches
                                    && <th className={"light"}><p className={"week"} onClick={() => { clickOnWeek(object.week) }}>S{ object.week.number }</p></th>
                                }
                                {
                                    indexDays.map((day, index2) => (
                                        <td key={index2}>{buildSelectable(object.days[day])}</td>
                                    ))
                                }
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </>
    }
    const buildMonthsCalendar = baseDate => {
        baseDate.startOf("year");
        let initialDate = moment(baseDate.format());
        let datas = emptyDictDates();
        let index = 0;
        let indexMonth = 0;

        for (let i = 0; i <= 11; i++) {
            if (index >= datas.length)
                break;

            datas[index].year = moment(initialDate.format());
            datas[index].months.push(moment(initialDate.month(i).format()));

            if (indexMonth >= 2) {
                index++;
                indexMonth = 0;
            }
            else {
                indexMonth++;
            }
        }

        return <>
            <p className={"title" + (initialDate.isSame(moment(), 'year') ? " now" : "")}>{ initialDate.format("YYYY") }</p>
            <table>
                <tbody>
                    <tr className={"header empty"}></tr>
                    {
                        datas.map((obj, index) => (
                            <tr key={index}>
                                {
                                    obj.months.map((month, index2) => (
                                        <td key={index2}>{ buildSelectable(month) }</td>
                                    ))
                                }
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </>
    }
    const buildQuartersCalendar = baseDate => {
        baseDate.startOf("year");
        let initialDate = moment(baseDate.format());
        let datas = emptyDictDates();

        datas[0].year = moment(initialDate.format());

        for (let i = 1; i < 5; i++) {
            datas[0].quarters.push(moment(initialDate.quarter(i).format()));
        }

        return <>
            <p className={"title" + (initialDate.isSame(moment(), 'year') ? " now" : "")}>{ initialDate.format("YYYY") }</p>
            <table>
                <tbody>
                    <tr className={"header empty"}></tr>
                    <tr>
                        {
                            datas[0].quarters.map((quarter, index) => (
                                <td key={index}>{ buildSelectable(quarter) }</td>
                            ))
                        }
                    </tr>
                </tbody>
            </table>
        </>
    }
    const buildYearsCalendar = () => {
        let baseDate = moment().startOf("year");
        let initialDate = moment(baseDate.format());
        let datas = emptyDictDates();
        let minDate = getMinYear();
        let count = 0;
        let index = 0;

        for (let i = parseInt(minDate.format("YYYY")); i <= parseInt(moment().format("YYYY")); i++) {
            datas[index].years[count] = moment(initialDate.year(i).format());

            count++;

            if (count === 5) {
                datas.push({
                    years: [null, null, null, null, null]
                });

                count = 0;
                index++;
            }
        }

        return <>
            <table>
                <tbody>
                <tr className={"header empty"}></tr>
                {
                    datas.map((line, index) => (
                        <tr key={index}>
                            {
                                line.years.map((year, index2) => (
                                    <td key={index2}>{buildSelectable(year)}</td>
                                ))
                            }
                        </tr>
                    ))
                }
                </tbody>
            </table>
        </>
    }
    const emptyDictDates = () => {
        let datas = [];

        switch (typeCompare) {
            case "dual_day":
            case "day":
                for (let i = 0; i < 6; i++) {
                    datas.push({
                        week: {
                            number: null,
                            year: null
                        },
                        days: {
                            0: null,
                            1: null,
                            2: null,
                            3: null,
                            4: null,
                            5: null,
                            6: null
                        }
                    })
                }

                break;
            case "month":
                for (let i = 0; i < 4; i++) {
                    datas.push({
                        year: null,
                        months: []
                    })
                }

                break;
            case "quarter":
                datas.push({
                    year: null,
                    quarters: []
                });

                break;
            case "year":
                datas.push({
                    years: [null, null, null, null, null]
                });

                break;
            default: break;
        }

        return datas;
    }
    const getMinYear = () => {
        let env = JSON.parse(localStorage.getItem("env"));
        let minDate = moment();

        switch (env.type) {
            case "company":
                if (env.stores !== undefined) {
                    for (let i in env.stores) {
                        if (env.stores[i].created_at === undefined || env.stores[i].created_at === null)
                            continue;

                        if (moment(env.stores[i].created_at).isBefore(minDate, "year"))
                            minDate = moment(env.stores[i].created_at);
                    }
                }
                else {
                    let company = new Company(JSON.parse(localStorage.getItem("company")));
                    minDate = moment(company.created_at);
                }

                break;
            case "store":
                let store = new Store(JSON.parse(localStorage.getItem("store")));
                minDate = moment(store.created_at);

                break;
            default: break;
        }

        return minDate;
    }
    const buildSelectable = object => {
        if (object == null)
            return <></>;

        let isNow = moment().isSame(object, typeCompare === "dual_day" ? "day" : typeCompare);
        let isSelected;

        switch (typeCompare) {
            case "dual_day":
            case "day":
                isSelected = dateIsSelected(object);

                return <p
                    className={"selectable" + (isNow ? " now" : "") + (isSelected.result ? " selected " + isSelected.place : "")}
                    onClick={() => { clickOnDate(object) }}>
                    { object.format("D") }
                </p>
            case "month":
                isSelected = dateIsSelected(object);

                return <p
                    className={"selectable" + (isNow ? " now" : "") + (isSelected.result ? " selected " + isSelected.place : "")}
                    onClick={() => { clickOnDate(object) }}>
                    { StringTools.capitalizeFirstLetter(object.format("MMM")) }
                </p>
            case "quarter":
                isSelected = dateIsSelected(object);

                return <p
                    className={"selectable" + (isNow ? " now" : "") + (isSelected.result ? " selected " + isSelected.place : "")}
                    onClick={() => { clickOnDate(object) }}>
                    { StringTools.capitalizeFirstLetter(object.format("Qo")) }
                </p>
            case "year":
                isSelected = dateIsSelected(object);

                return <p
                    className={"selectable" + (isNow ? " now" : "") + (isSelected.result ? " selected " + isSelected.place : "")}
                    onClick={() => { clickOnDate(object) }}>
                    { StringTools.capitalizeFirstLetter(object.format("YYYY")) }
                </p>
            default: break;
        }

    }
    const dateIsSelected = date => {
        let result = {
            result: false,
            place: ""
        }
        let toCompare = typeCompare === "dual_day" ? "day" : typeCompare;

        if (value === null)
            return result;

        if (value.end !== null) {
            result.result = date.isBetween(value.begin, value.end, toCompare, "[]");

            if (result.result) { // calcul place
                let start = false;
                let end = false;

                if (moment(value.begin).isSame(date, toCompare))
                    start = true;

                if (moment(value.end).isSame(date, toCompare))
                    end = true;

                if (start && !end)
                    result.place = "start";
                else if (!start && end)
                    result.place = "end";
                else if (start && end)
                    result.place = "alone";
                else
                    result.place = "between";
            }
        }
        else {
            if (moment(value.begin).isSame(date, toCompare)) {
                result.result = true;
                result.place = "alone";
            }
        }

        return result;
    }
    const clickOnWeek = week => {
        const begin = moment(week.year, "YYYY").week(week.number).startOf('week');
        const end = moment(week.year, "YYYY").week(week.number).endOf('week');

        if (nbClick === 1) {
            changeDate({
                begin: begin.format(),
                end: end.format()
            });

            setNbClick(2);
        }
        else {
            if (begin.isBefore(value.begin)) {
                changeDate({
                    begin: begin.format(),
                    end: value.end
                });
            }
            else {
                changeDate({
                    begin: value.begin,
                    end: end.format()
                });
            }

            setNbClick(1);
        }
    }
    const clickOnDate = (date, only = false) => {
        if (only) {
            changeDate({
                begin: date.startOf(typeCompare === "dual_day" ? "day" : typeCompare).format(),
                end: date.startOf(typeCompare === "dual_day" ? "day" : typeCompare).endOf(typeCompare).format()
            });

            close();
        }
        else if (baseValue !== undefined && baseValue !== null) {
            let add = 0;
            let addType = "days";

            switch (typeCompare) {
                case "dual_day":
                case "day":
                    add = Math.abs(moment(baseValue.begin).diff(moment(baseValue.end), "days"));
                    addType = "days";
                    break;
                case "month":
                    add = Math.abs(moment(baseValue.begin).diff(moment(baseValue.end), "months"));
                    addType = "months";
                    break;
                case "year":
                    add = Math.abs(moment(baseValue.begin).diff(moment(baseValue.end), "years"));
                    addType = "years";
                    break;
                default: break;
            }

            changeDate({
                begin: date.startOf(typeCompare === "dual_day" ? "day" : typeCompare).format(),
                end: date.startOf(typeCompare === "dual_day" ? "day" : typeCompare).add(add, addType).endOf(addType).format()
            });
        }
        else {
            if (nbClick === 1) {
                changeDate({
                    begin: date.startOf(typeCompare === "dual_day" ? "day" : typeCompare).format(),
                    end: date.startOf(typeCompare === "dual_day" ? "day" : typeCompare).endOf(typeCompare).format()
                });

                setNbClick(2);
            }
            else {
                if (date.isBefore(value.begin)) {
                    changeDate({
                        begin: date.startOf(typeCompare === "dual_day" ? "day" : typeCompare).format(),
                        end: moment(value.begin).endOf(typeCompare).format()
                    });
                }
                else {
                    changeDate({
                        begin: value.begin,
                        end: date.endOf(typeCompare).format()
                    });
                }

                setNbClick(1);
            }
        }
    }
    const changeDate = dates => {
        change(dates);
    }

    useEffect(() => {
        setTypeCompare(type);
    }, [type]);
    useEffect(() => {
        if (typeCompare === "dual_day" && window.matchMedia('(max-width: 1000px)').matches)
            setTypeCompare("day");
    }, [typeCompare]);
    useEffect(() => {
        let reinit = false;

        if (prevType !== typeCompare)
            reinit = true;

        initCalendars(reinit);
    }, [value, typeCompare]);
    useEffect(() => {
        if (calendarOpened) {
            setNbClick(1);
            initCalendars(true);

            window.addEventListener('resize', initCalendarPosition);
            window.addEventListener('scroll', initCalendarPosition);
        }
        else {
            window.removeEventListener('resize', initCalendarPosition);
            window.removeEventListener('scroll', initCalendarPosition);
        }
    }, [calendarOpened]);

    return (
        <>
            {
                attribute === "dateCompare"
                    ? <p id={"DateSelector_" + idRandom} className={classname + (loading.global ? " loadingLocked" : "")} onClick={open}>{buildDatesString(true)}</p>
                    : <div id={"DateSelector_" + idRandom} className={"DateSelector" + (classname !== undefined ? " " + classname : "") + (calendarOpened ? " opened" : "") + (loading.global ? " loadingLocked" : "")} onClick={open}>
                        <CalendarIcon classname={"icon"}/>
                        <div className={"containerText"}>
                            <p className={"text" + (noCompare ? " noSubText" : "")}>{buildDatesString()}</p>
                            {!noCompare && <p className={"subText"}>vs. {buildComparesString()}</p>}
                        </div>
                    </div>
            }
            <div id={"calendar_" + idRandom} className={"calendar " + typeCompare + (calendarOpened ? " visible" : "")}>
                { calendarContent() }
            </div>
        </>
    )
}

export default DateSelector;
